/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Not_FoundInputs */

const th_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผู้เล่นรายนี้`)
};

const en_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No such player.`)
};

const ja_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該当する選手がいません。`)
};

const zh_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该球员不存在。`)
};

const es_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No existe ese jugador.`)
};

const pt_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse jogador não existe.`)
};

const id_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tidak ada.`)
};

const fr_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce joueur n’existe pas.`)
};

const tl_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang manlalarong iyon.`)
};

const vi_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có cầu thủ đó.`)
};

const ko_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 선수는 없습니다.`)
};

const de_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Spieler gibt es nicht.`)
};

const ru_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого игрока нет.`)
};

const tr_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir oyuncu yok.`)
};

const it_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel giocatore non esiste.`)
};

const pl_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taki zawodnik nie istnieje.`)
};

const uk_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого гравця немає.`)
};

const hi_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह खिलाड़ी मौजूद नहीं है।`)
};

const ar_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك اللاعب غير موجود.`)
};

const ms_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tidak wujud.`)
};

const bn_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই খেলোয়াড় নেই।`)
};

const zh_tw2_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球員不存在。`)
};

const zh_hk2_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球員不存在。`)
};

const ur_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ کھلاڑی موجود نہیں۔`)
};

const fa_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین بازیکنی وجود ندارد.`)
};

const sw_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji huyo hayupo.`)
};

const nl_player_not_found = /** @type {(inputs: Player_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die speler bestaat niet.`)
};

/**
* | output |
* | --- |
* | "No such player." |
*
* @param {Player_Not_FoundInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_not_found = /** @type {((inputs?: Player_Not_FoundInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Not_FoundInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_not_found(inputs)
	if (locale === "ja") return ja_player_not_found(inputs)
	if (locale === "zh") return zh_player_not_found(inputs)
	if (locale === "es") return es_player_not_found(inputs)
	if (locale === "pt") return pt_player_not_found(inputs)
	if (locale === "id") return id_player_not_found(inputs)
	if (locale === "fr") return fr_player_not_found(inputs)
	if (locale === "tl") return tl_player_not_found(inputs)
	if (locale === "vi") return vi_player_not_found(inputs)
	if (locale === "ko") return ko_player_not_found(inputs)
	if (locale === "de") return de_player_not_found(inputs)
	if (locale === "ru") return ru_player_not_found(inputs)
	if (locale === "tr") return tr_player_not_found(inputs)
	if (locale === "it") return it_player_not_found(inputs)
	if (locale === "pl") return pl_player_not_found(inputs)
	if (locale === "uk") return uk_player_not_found(inputs)
	if (locale === "hi") return hi_player_not_found(inputs)
	if (locale === "ar") return ar_player_not_found(inputs)
	if (locale === "ms") return ms_player_not_found(inputs)
	if (locale === "bn") return bn_player_not_found(inputs)
	if (locale === "zh-TW") return zh_tw2_player_not_found(inputs)
	if (locale === "zh-HK") return zh_hk2_player_not_found(inputs)
	if (locale === "ur") return ur_player_not_found(inputs)
	if (locale === "fa") return fa_player_not_found(inputs)
	if (locale === "sw") return sw_player_not_found(inputs)
	if (locale === "nl") return nl_player_not_found(inputs)
	return en_player_not_found(inputs)
});